import * as m from "../../es2015/plugins/wordCloud";
window.am4plugins_wordCloud = m;


//////////////////
// WEBPACK FOOTER
// ./plugins/wordCloud.js
// module id = null
// module chunks = 